import LazyImage from './LazyImage'

export { LazyImage }
